// src/pages/layout/Layout.tsx
import { Outlet, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "../../analytics";
import company_logo_box from "../../assets/swisslife-logo-small.svg";
import ai_icon from "../../assets/AI.svg";
import styles from "./Layout.module.css";
import { LanguageSwitcher } from "../../i18n/LanguageSwitcher";
import { useTranslation } from "../../i18n/useTranslation";
// pulled from the .env.<mode> file
declare const __INTRANET_LINK__: string;
const companyLink = __INTRANET_LINK__ as string;

const Layout = () => {
    const { t, lang } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        const pathSegment =
            location.pathname === "/"
                ? "lifenet:ai-search"
                : location.pathname.slice(1).replace(/\//g, ":");
        const pageName = `${lang}:${pathSegment}`;

        trackPageView({
            pageName,
            title: document.title,
            url: window.location.origin + location.pathname,
            lang,
            domain: window.location.host,
            fullUrl: window.location.href,
        });
    }, [location, lang]);

    return (
        <div className={styles.layout}>
            <header className={styles.header} role="banner">
                <div className={styles.headerContainer}>
                    <div className={styles.leftGroup}>
                        <Link
                            to="/"
                            className={styles.headerTitleContainer}
                            onClick={(e) => {
                                e.preventDefault();
                                window.location.href = window.location.origin + "/";
                                window.location.reload();
                            }}
                        >
                            <img
                                src={ai_icon}
                                alt="AI Icon"
                                aria-label="AI Icon"
                                className={styles.headerIcon}
                            />
                            <p className={styles.headerTitle}>{t("intranet.label")}</p>
                        </Link>
                    </div>
                    <div className={styles.rightGroup}>
                        <LanguageSwitcher />
                        <a href={companyLink}>
                            <img
                                src={company_logo_box}
                                alt="Company logo"
                                aria-label="Company logo"
                                className={styles.headerCompanyLogo}
                            />
                        </a>
                    </div>
                </div>
            </header>
            <Outlet />
        </div>
    );
};

export default Layout;
